import React from "react"

import ThemeHeaderComponent from "./theme-header-component"

class ThemeHeaderContainer extends React.Component {

	render() {
		return (
			<ThemeHeaderComponent {...this.props} onToggleTheme={this.props.onToggleTheme} />
		)
	}
}

export default ThemeHeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/theme-header-container.js